




    import {Vue, Component, Mixins} from 'vue-property-decorator';
    import {nil, stripeKeys} from '@/common';
import PostPurchaseScreen from '@/components/Views/UI/PostPurchaseScreen.vue';
    import CancelBookingProcessMixin from '@/mixins/CancelBookingProcessMixin.vue';
    import {serviceAsDataLayerProduct} from "@/utils";

@Component({
    components: {PostPurchaseScreen},
})
export default class OrderConfirm extends Mixins(CancelBookingProcessMixin) {
    public mounted() {
        this.getOrder();
    }

    public async getOrder() {
        const {Order} = this.$FeathersVuex;
        const order = await Order.get(this.$route.params.order);
        const products = order.bookingModels.map(x=>serviceAsDataLayerProduct(x.purchasableModel));
        const {servicesTotal, proTipTotal, giftCardPaymentSubmitted, discountTotal} = order;
        const giftCard = nil(giftCardPaymentSubmitted)
            ? 0
            : giftCardPaymentSubmitted;
        const discount = nil(discountTotal) ? 0 : giftCardPaymentSubmitted;
        const revenue = (servicesTotal + proTipTotal - giftCard - discount).toFixed(2);
        window.dataLayer.push({
          event:'purchase',
          ecommerce:{
              userId:order.purchaserModel.email,
              actionField:{
                  id: order._id,
                  revenue,
              },
              products,
          }
        })
        /*stripe.checkout.sessions.retrieve(order.stripeSessionId, (err, session)=>{
            console.log("error : ");
            console.log(err);
            console.log("session : ");
            console.log(session);
        })*/
    }
}
